export default __webpack_public_path__ + "static/champion-htf-featherweight-webfont-232a488a9dd8b5d2af2e50be14bda815.ttf";